var content = require("!!../node_modules/_@angular-devkit_build-angular@0.803.29@@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../node_modules/_postcss-loader@3.0.0@postcss-loader/src/index.js??embedded!../node_modules/_sass-loader@7.2.0@sass-loader/lib/loader.js??ref--15-3!./styles.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../node_modules/_style-loader@1.0.0@style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
